import { UPDATE_SLIDER_START, UPDATE_SLIDER_SUCCESS, UPDATE_SLIDER_FAIL } from '../actions/ActionsTypes';

const initialState = {
    success: false,
    error: null,
    loading: false,
};


export default function (state = initialState, action) {
    switch (action.type) {
        case UPDATE_SLIDER_START:
            return {
                ...state,
                loading: true,
                error: false
            }
        case UPDATE_SLIDER_SUCCESS:
            return {
                ...state,
                success: true,
                error: null,
                loading: false
            }
        case UPDATE_SLIDER_FAIL:
            return {
                ...state,
                success: false,
                error: true,
                loading: false,
            }
        default:
            return state;
    }
}